import React from "react";
import "./ForMen.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

/* 🔥 REQUIRED IMPORTS */
import products from "../../data/products";
import ReviewSlider from "../ReviewSlider";
import FeaturesSection from "../FeaturesSection";
import BlogSection from "../BlogPage";

const ForCouples = () => {
  /* ✅ ONLY FILTER – NO LOCAL DATA */
  const coupleProducts = products.filter(
    (item) => item.category === "couples"
  );

  return (
    <>
      {/* 🔹 SEO META */}
      <Helmet>
        <title>
          Best Sex Toys for Couples in India | Discreet Delivery – LushDesire
        </title>
        <meta
          name="description"
          content="Shop premium sex toys for couples in India. Buy BDSM kits, belt condoms, vibrators & pleasure products with discreet delivery across India."
        />
        <link rel="canonical" href="https://lushdesire.in/couples" />
      </Helmet>

      {/* 🔹 H1: Main Page Heading */}
      <section className="men-page">
        <div className="container">
          <h1 className="men-title" style={{ textAlign: "center", marginBottom: "20px" }}>
            Premium Sex Toys & Pleasure Products for Couples in India
          </h1>

          {/* 🔹 SEO Intro - H2/H3 */}
          <div style={{ textAlign: "center", marginBottom: "40px" }}>
            <h2 style={{ fontSize: "1.6rem", fontWeight: "600" }}>
              Shop BDSM Kits, Belt Condoms & Couple Accessories
            </h2>
            <h3 style={{ fontSize: "1.2rem", color: "#555", fontWeight: "400" }}>
              Enhance intimacy & pleasure with discreet delivery across India
            </h3>
          </div>

          {/* 🔹 Product Grid - H2 Section */}
         

          <div className="men-grid">
            {coupleProducts.map((item) => (
              <div className="men-card" key={item.id}>
                <img
                  src={process.env.PUBLIC_URL + item.image}
                  alt={`${item.name} for couples with discreet delivery in India`}
                  loading="lazy"
                />

                {/* 🔹 Product Name - H3 */}
                <h3 className="product-name">{item.name}</h3>

                {/* 🔹 Price Info */}
                <div className="price-box">
                  <span className="mrp">₹{item.mrp}</span>
                  <span className="price">₹{item.price}</span>
                </div>

                {/* 🔹 Order Button - H4 for SEO structure */}
                <h4 style={{ textAlign: "center", marginTop: "10px" }}>
                  <Link
                    to={`/product/${item.id}`}
                    className="order-btn"
                  >
                    Order Now
                  </Link>
                </h4>

                {/* 🔹 Optional Short Description - H5 */}
                <h5 style={{ fontSize: "0.9rem", color: "#777", marginTop: "8px", textAlign: "center" }}>
                 Sex toys For Men , women or Couples
                </h5>
              </div>
            ))}
          </div>

          {/* SAFETY CHECK */}
          {coupleProducts.length === 0 && (
            <p style={{ textAlign: "center", marginTop: "20px" }}>
              No products found for couples.
            </p>
          )}
        </div>
      </section>

      {/* 🔹 Supporting Sections */}
      <FeaturesSection />
      <ReviewSlider />
      <BlogSection />
    </>
  );
};

export default ForCouples;
